import { getAgreement } from 'client/api/agreementApi'
import BaseEntityNew from 'client/components/core/BaseEntity/BaseEntityNew'
import { usePage } from 'client/store'
import pageSelectors from 'client/store/page/pageSelectors'
import { EntityProps } from 'client/types'
import React, { useEffect, useState } from 'react'
import { CommonAgreement } from 'src/shared/components/agreement'
import { AgreementInterface } from 'src/shared/entities/agreement/agreement.schema'

export const Agreement = ({
  entity,
  isMoveDownAllowed,
  isMoveUpAllowed,
}: EntityProps<AgreementInterface>) => {
  const pageId = usePage(pageSelectors.getPageId)

  const [agreementText, setAgreementText] = useState<string>('')

  useEffect(() => {
    getAgreement(pageId).then(res => {
      // remove escape characters
      const sanitizedText = res.data.replace(/\\"/g, '"')
      setAgreementText(sanitizedText)
    })
  }, [pageId])

  if (!agreementText) {
    return null
  }

  return (
    <BaseEntityNew
      entity={entity}
      isMoveDownAllowed={isMoveDownAllowed}
      isMoveUpAllowed={isMoveUpAllowed}
    >
      <CommonAgreement id={entity.htmlAttrId} text={agreementText} />
    </BaseEntityNew>
  )
}
